import React, { useId } from 'react';

const ReviewRequestAppSvg = ({ color = '#000', size = 24, ...props }) => {
    const clipId = useId().replace(/:/g, '_');
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
            <g clipPath={`url(#${clipId})`}>
                <path
                    d="M16.6667 2.6665H7.33333C6.97971 2.6665 6.64057 2.80698 6.39052 3.05703C6.14048 3.30708 6 3.64622 6 3.99984V19.9998C6 20.3535 6.14048 20.6926 6.39052 20.9426C6.64057 21.1927 6.97971 21.3332 7.33333 21.3332H16.6667C17.0203 21.3332 17.3594 21.1927 17.6095 20.9426C17.8595 20.6926 18 20.3535 18 19.9998V3.99984C18 3.64622 17.8595 3.30708 17.6095 3.05703C17.3594 2.80698 17.0203 2.6665 16.6667 2.6665ZM12.6667 19.9998H11.3333V18.6665H12.6667V19.9998ZM7.33333 17.3332V3.99984H16.6667V17.3332H7.33333Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id={clipId}>
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default ReviewRequestAppSvg;
